// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-alert[data-v-154f5a44] {\n  filter: brightness(100%);\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n.v-alert[data-v-154f5a44]:hover {\n  filter: brightness(160%);\n}\n.icn[data-v-154f5a44] {\n  opacity: 0.7;\n  transition: opacity 0.3s ease-in-out;\n}\n.v-alert:hover > .icn[data-v-154f5a44] {\n  opacity: 1;\n  color: var(--v-stark-base);\n}\n", ""]);
// Exports
module.exports = exports;
